import React, { useState } from 'react'
import { HiOutlineArrowSmRight, HiX } from 'react-icons/hi'
import './popupmodel.css'
import { BsBoxArrowUpRight } from 'react-icons/bs'

const ProjectItems = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="project__card" key={item.id}>
      <img className="project__img" src={item.image} alt="" />
      <h3 className="project__title">{item.title}</h3>
      <span onClick={toggleModal} className="project__button">
        View more <HiOutlineArrowSmRight className="project__button-icon" />
      </span>

      {isOpen && (
        <div className="project__modal active-modal">
          <div className="project__modal-overlay" onClick={toggleModal}></div>
          <div className="project__modal-content">
            <HiX onClick={toggleModal} className="project__modal-close" />
            <h3 className="project__modal-title">{item.title}</h3>
            <p className="project__modal-description">{item.description}</p>
            <div className="project__modal-buttons">
              {item.github && (
                <a
                  href={item.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project__modal-button"
                >
                  GitHub
                  <BsBoxArrowUpRight className="arrow_icon" />
                </a>
              )}
              {item.demo && (
                <a
                  href={item.demo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project__modal-button"
                >
                  Demo
                  <BsBoxArrowUpRight className="arrow_icon" />
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProjectItems
